<template>
  <div class="container-w">
    <div class="t1 m-card">
      <tablediv
        type="warehouse"
        :tableheader="tableheader"
        :header="'Stock List'"
      />
    </div>
    <div class="m1 m-card"><maplocation :header="'Warehouse Location'" /></div>
    <div
      @click="popupAdd = true"
      class="a1 m-card btn"
      style="background: #6bd17a"
    >
      <cheackin
        :header="'Check in'"
        :img="require('@/assets/images/Stock/Checkin.png')"
      />
    </div>
    <vs-popup title="Add New Item in to Stock" :active.sync="popupAdd">
      <PopupAdd :timeStamp="timeStamp" v-on:close-popup-add="closePopupAdd" />
    </vs-popup>
    <div
      @click="popupRemove = true"
      class="a2 m-card btn"
      style="background: #fd7979"
    >
      <cheackin
        :header="'Check out'"
        :img="require('@/assets/images/Stock/CheckOut.png')"
      />
    </div>
    <vs-popup title="Remove Item in to Stock" :active.sync="popupRemove">
      <PopupRemove
        :timeStamp="timeStamp"
        v-on:close-popup-remove="closePopupRemove"
      />
    </vs-popup>
    <div class="a3">
      <div class="c1 m-card">
        <warehouse
          :header="'Warehouse 01'"
          :detail="'อาคารพร้อมพันธุ์ 1 ชั้น 5 Lat Phrao Rd, Chom Phon, Chatuchak, Bangkok 10900'"
        />
      </div>
      <div class="c2 m-card">
        <totaliteminstock :header="'Total Item in Stock'" />
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import warehouse from "./components/div_warehouse.vue";
import cheackin from "./components/Checkin.vue";
import totaliteminstock from "./components/TotalIteminStock.vue";
import maplocation from "./components/map.vue";
import tablediv from "./components/tableStockList.vue";
import PopupAdd from "./components/PopupAdd.vue";
import PopupRemove from "./components/PopupRemove.vue";
export default {
  components: {
    warehouse,
    maplocation,
    totaliteminstock,
    cheackin,
    tablediv,
    PopupAdd,
    PopupRemove,
  },
  data() {
    return {
      currentTime: "",
      tableheader: [
        "Timestamp",
        "Tag Name",
        "EQC",
        "RSSI",
        "Serial No.",
        "Count",
      ],
      popupAdd: false,
      popupRemove: false,
      timeStamp: "",
      timeNow: null,
    };
  },
  methods: {
    closePopupAdd(value) {
      // console.log("click close from child",value);
      this.popupAdd = value;
    },
    closePopupRemove(value) {
      // console.log("click close from child",value);
      this.popupRemove = value;
    },
  },

  mounted() {
    // console.log("rrrrrrrrrrrrrrrrr"+this.$route.query.id);
    this.timeNow = setInterval(() => {
      this.timeStamp = moment().format("DD/MM/YYYY LTS");
    }, 1000);
  },
  beforeDestroy() {
    clearInterval(this.timeNow);
  },
  computed: {
    // category() {
    //   console.log(this.$route.query.id);
    //   return this.$route.query.id;
    // },
  },
};
</script>

<style scoped>
.container-w {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-template-rows: 1fr 0.5fr auto;
  gap: 10px 10px;
  grid-auto-flow: row;
  grid-template-areas:
    "a3 a3 m1 m1"
    "a1 a2 m1 m1"
    "t1 t1 t1 t1";
}
.m-card {
  justify-content: center;
}
.t1 {
  grid-area: t1;
}

.m1 {
  grid-area: m1;
}

.a1 {
  grid-area: a1;
}

.a2 {
  grid-area: a2;
}

.a3 {
  display: grid;
  grid-template-columns: 1.5fr 1fr;
  grid-template-rows: 1fr;
  gap: 10px 10px;
  grid-auto-flow: row;
  grid-template-areas: "c1 c2";
  grid-area: a3;
}

.c1 {
  grid-area: c1;
}

.c2 {
  grid-area: c2;
}
.btn:hover {
  box-shadow: 0 9px 28px -9px;
  color: #fff;
  transition: all 0.2s ease;
}
@media only screen and (max-width: 700px) {
  .container-w {
    grid-template-columns: auto;
    grid-template-rows: auto;
    /* grid-auto-rows: 1fr; */
    grid-auto-flow: row;
    grid-template-areas:
      "a3 "
      "a1 "
      "a2" 
      "m1"
      "t1 ";
  }
  .a3 {
    /* display: grid; */
    grid-template-columns: 100%;
    grid-template-rows: auto;
    /* gap: 10px 10px; */
    grid-auto-flow: row;
    grid-template-areas: "c1" "c2";
    /* grid-area: d1; */
  }
}
</style>